'use client'

import * as React from 'react'
// import { GripVerticalIcon } from 'lucide-react'
import * as ResizablePrimitive from 'react-resizable-panels'

import { cn } from '@/lib/utils'

function ResizablePanelGroup({
    className,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) {
    return (
        <ResizablePrimitive.PanelGroup
            data-slot="resizable-panel-group"
            className={cn(
                'flex h-full w-full data-[panel-group-direction=vertical]:flex-col',
                className
            )}
            {...props}
        />
    )
}

function ResizablePanel({ ...props }: React.ComponentProps<typeof ResizablePrimitive.Panel>) {
    return <ResizablePrimitive.Panel data-slot="resizable-panel" {...props} />
}

function ResizableHandle({
    withHandle,
    className,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
    withHandle?: boolean
}) {
    return (
        <ResizablePrimitive.PanelResizeHandle
            data-slot="resizable-handle"
            className={cn(
                'bg-transparent group relative flex w-0.5 items-center justify-center focus-visible:outline-none data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:translate-x-0 data-[panel-group-direction=vertical]:after:-translate-y-1/2 [&[data-panel-group-direction=vertical]>div]:rotate-90 transition-all duration-200 hover:bg-blue-400 overflow-visible',
                className
            )}
            {...props}
        >
            {withHandle && (
                <div className="absolute backdrop-blur-[39px] border border-black/6 dark:border-white/6 bg-black/6 dark:bg-white/6 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 flex h-10 w-0 opacity-0 group-hover:opacity-100 group-hover:w-2 group-hover:h-6 hover:w-2 hover:h-9 items-center justify-center rounded-full transition-all duration-200">
                    {/* <GripVerticalIcon className="size-2.5"/> */}
                    {/* <div className="size-2.5 h-5" /> */}
                </div>
            )}
        </ResizablePrimitive.PanelResizeHandle>
    )
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle }
